import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Permission } from 'src/app/data/model/permission';
import { User, UserTableVisualization } from 'src/app/data/model/user';
import { UserPortalGroup } from 'src/app/data/model/user-portal-group';
import { AppActions, AppSelectors } from 'src/app/store/app-store';
import { environment } from 'src/environments/environment.api';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent  {
  @Input() group: UserPortalGroup[];

  public user$: Observable<User> = this.store.select(AppSelectors.selectUser);
  public viewPermission$: Observable<Permission[]> = this.store.select(
    AppSelectors.selectViewPermssions
  );
  viewModules$: Observable<UserTableVisualization[]> =this.store.select(
    AppSelectors.selectViewModules
  );

  public getGroup(groups: UserPortalGroup[]) {
    return groups[0]?.group_item?.custom_logo
  }

  subscription: Subscription;


  constructor(private store: Store) {}

  setUrl(){
    if(this.group[0]?.group_item?.custom_logo){
      return `${environment.apiUrl}/${this.group[0]?.group_item.custom_logo}`
    } else {
      return "/../assets/images/logo-colori.png"//new_logo_wt_400x138_01.png"
    }
  }
  public toggleMenu() {
    this.store.dispatch(AppActions.toggleNav());
  }
}
